import Popup from "./Popup";

export default function PopupErrorClip({
  isOpen,
  onPrimaryClick,
  onClose,
}: {
  isOpen: boolean;
  onPrimaryClick: () => void;
  onClose: () => void;
}) {
  return (
    <Popup
      heading="エラー"
      subheading="クーポンの保存に失敗しました。"
      primaryButtonLabel="戻る"
      onPrimaryClick={onPrimaryClick}
      testId="popup-error-clip"
      isOpen={isOpen}
      onClose={onClose}
    />
  );
}
